import { createFileRoute, useSearch } from '@tanstack/react-router';
import { ContainerTypeLegacy, ExportTelemetryForm } from '@amber-ui/core';

function BargeExportTelemetryRoute() {
  const { barge } = useSearch({ strict: false }) as { barge?: string };
  const barge_id = barge || null;

  if (!barge_id) return null;

  return <ExportTelemetryForm container_id={barge_id} container_type={ContainerTypeLegacy.barge} />;
}

export const Route = createFileRoute('/_auth/_barge/barge/export_telemetry')({
  component: BargeExportTelemetryRoute,
});
